// // src/pages/Admin/AdminDashboardPage.jsx
// import React, { useEffect, useState, useContext } from "react";
// import toast from "react-hot-toast";
// import api from "../../utils/api";
// import { AuthContext } from "../../context/AuthContext";
// import { useNavigate } from "react-router-dom";
// import { getImageUrl } from "../../utils/imageUrl";

// export default function AdminDashboardPage() {
//   const { user } = useContext(AuthContext);
//   const navigate = useNavigate();

//   const [loading, setLoading] = useState(true);
//   const [stats, setStats] = useState({
//     totalListings: 0,
//     pendingApprovals: 0,
//     confirmedDeals: 0,
//     revenue: 0,
//     pendingListings: [],
//     dealsAwaitingVerification: [],
//     completedDeals: [],
//   });

//   // 👉 for modal preview
//   const [selectedListing, setSelectedListing] = useState(null);
//   const [showDetails, setShowDetails] = useState(false);

//   useEffect(() => {
//     if (!user) {
//       navigate("/login");
//       return;
//     }
//     if (user.role !== "ADMIN") {
//       navigate("/");
//       return;
//     }

//     async function load() {
//       try {
//         setLoading(true);
//         const res = await api.get("/admin/dashboard");
//         setStats(res.data);
//       } catch (err) {
//         console.error(err);
//         toast.error(err?.response?.data?.message || "Failed to load admin dashboard");
//       } finally {
//         setLoading(false);
//       }
//     }

//     load();
//   }, [user, navigate]);

//   // 👉 approve / reject listing
//   async function handleReview(listingId, nextStatus) {
//     const remarks =
//       nextStatus === "REJECTED"
//         ? window.prompt("Reason for rejection (optional):") || ""
//         : "";

//     try {
//       await api.put(`/admin/listings/${listingId}/review`, {
//         status: nextStatus,
//         remarks,
//       });

//       // optimistic update of local state
//       setStats((prev) => ({
//         ...prev,
//         pendingApprovals: Math.max(prev.pendingApprovals - 1, 0),
//         pendingListings: prev.pendingListings.filter((l) => l.id !== listingId),
//       }));

//       // close modal if it was this listing
//       if (selectedListing && selectedListing.id === listingId) {
//         setShowDetails(false);
//         setSelectedListing(null);
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error(err?.response?.data?.message || "Failed to update listing");
//     }
//   }

//   // 👉 open / close listing details modal
//   function openListingDetails(listing) {
//     setSelectedListing(listing);
//     setShowDetails(true);
//   }

//   function closeDetails() {
//     setShowDetails(false);
//     setSelectedListing(null);
//   }

//   if (loading) {
//     return (
//       <div className="max-w-7xl mx-auto px-6 py-10">
//         Loading admin dashboard...
//       </div>
//     );
//   }

//   return (
//     <div className="max-w-7xl mx-auto px-6 py-10">
//       <h1 className="text-3xl font-semibold">Admin Dashboard</h1>
//       <p className="text-gray-500 mb-6">
//         Review room listings and verify completed deals.
//       </p>

//       {/* Top stats cards */}
//       <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
//         {[
//           { label: "Total Listings", value: stats.totalListings },
//           { label: "Pending Listing Approvals", value: stats.pendingApprovals },
//           { label: "Confirmed Deals", value: stats.confirmedDeals },
//           {
//             label: "Total Revenue (Service Charges)",
//             value: `Rs. ${stats.revenue}`,
//           },
//         ].map((box, i) => (
//           <div
//             key={i}
//             className="bg-white shadow rounded-xl p-6 text-center border border-gray-50"
//           >
//             <div className="text-2xl font-bold text-gray-900">{box.value}</div>
//             <div className="text-gray-500 text-sm mt-1">{box.label}</div>
//           </div>
//         ))}
//       </div>

//       {/* Pending Listings */}
//       <div className="bg-white rounded-xl shadow p-6 mb-8">
//         <div className="flex items-center justify-between mb-4">
//           <h2 className="text-lg font-semibold">Pending Listings</h2>
//           <span className="text-sm text-gray-500">
//             {stats.pendingListings.length} pending approval
//           </span>
//         </div>

//         {stats.pendingListings.length === 0 ? (
//           <p className="text-gray-500 text-sm">
//             No pending listings at the moment.
//           </p>
//         ) : (
//           <div className="overflow-x-auto">
//             <table className="w-full text-sm">
//               <thead className="border-b bg-gray-50">
//                 <tr className="text-left">
//                   <th className="py-2 px-3">Title</th>
//                   <th className="py-2 px-3">Owner</th>
//                   <th className="py-2 px-3">Location</th>
//                   <th className="py-2 px-3">Rent (Rs.)</th>
//                   <th className="py-2 px-3">Created</th>
//                   <th className="py-2 px-3 text-center">Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {stats.pendingListings.map((listing) => (
//                   <tr
//                     key={listing.id}
//                     className="border-b last:border-0 hover:bg-gray-50/60"
//                   >
//                     <td className="py-2 px-3">
//                       <div className="font-semibold text-gray-900">
//                         {listing.title}
//                       </div>
//                       <div className="text-xs text-gray-500">
//                         Type: {listing.roomType}
//                       </div>
//                     </td>
//                     <td className="py-2 px-3">
//                       <div className="text-sm">
//                         {listing.owner?.fullName || "Unknown owner"}
//                       </div>
//                       <div className="text-xs text-gray-500">
//                         {listing.owner?.email}
//                       </div>
//                     </td>
//                     <td className="py-2 px-3">{listing.location}</td>
//                     <td className="py-2 px-3">Rs. {listing.rentAmount}</td>
//                     <td className="py-2 px-3 text-xs text-gray-500">
//                       {listing.createdAt
//                         ? new Date(listing.createdAt).toLocaleDateString()
//                         : "-"}
//                     </td>
//                     <td className="py-2 px-3">
//                       <div className="flex gap-2 justify-center flex-wrap">
//                         {/* View -> open modal */}
//                         <button
//                           onClick={() => openListingDetails(listing)}
//                           className="px-3 py-1 rounded-full text-xs font-medium border border-gray-300 text-gray-700 hover:bg-gray-100"
//                         >
//                           View
//                         </button>

//                         {/* Quick approve/reject */}
//                         <button
//                           onClick={() => handleReview(listing.id, "APPROVED")}
//                           className="px-3 py-1 rounded-full text-xs font-medium bg-emerald-50 text-emerald-700 border border-emerald-100 hover:bg-emerald-100"
//                         >
//                           Approve
//                         </button>
//                         <button
//                           onClick={() => handleReview(listing.id, "REJECTED")}
//                           className="px-3 py-1 rounded-full text-xs font-medium bg-red-50 text-red-700 border border-red-100 hover:bg-red-100"
//                         >
//                           Reject
//                         </button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}
//       </div>

//       {/* Deals awaiting admin verification */}
//       <div className="bg-white rounded-xl shadow p-6 mb-8">
//         <div className="flex items-center justify-between mb-4">
//           <h2 className="text-lg font-semibold">Deals Awaiting Verification</h2>
//           <span className="text-sm text-gray-500">
//             {stats.dealsAwaitingVerification.length} pending confirmation
//           </span>
//         </div>

//         {stats.dealsAwaitingVerification.length === 0 ? (
//           <p className="text-gray-500 text-sm">
//             No deals waiting for admin verification right now.
//           </p>
//         ) : (
//           <div className="overflow-x-auto">
//             <table className="w-full text-sm">
//               <thead className="border-b bg-gray-50">
//                 <tr className="text-left">
//                   <th className="py-2 px-3">Room</th>
//                   <th className="py-2 px-3">Seeker</th>
//                   <th className="py-2 px-3">Owner</th>
//                   <th className="py-2 px-3">Rent (Rs.)</th>
//                   <th className="py-2 px-3">Service Charge (Rs.)</th>
//                   <th className="py-2 px-3 text-center">Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {stats.dealsAwaitingVerification.map((d) => (
//                   <tr
//                     key={d.id}
//                     className="border-b last:border-0 hover:bg-gray-50/60"
//                   >
//                     <td className="py-2 px-3">
//                       <div className="font-semibold text-gray-900">
//                         {d.listing?.title || "N/A"}
//                       </div>
//                       <div className="text-xs text-gray-500">
//                         {d.listing?.location}
//                       </div>
//                     </td>
//                     <td className="py-2 px-3">
//                       <div className="text-sm">
//                         {d.seeker?.fullName || "Unknown seeker"}
//                       </div>
//                       <div className="text-xs text-gray-500">
//                         {d.seeker?.email}
//                       </div>
//                     </td>
//                     <td className="py-2 px-3">
//                       <div className="text-sm">
//                         {d.owner?.fullName || "Unknown owner"}
//                       </div>
//                       <div className="text-xs text-gray-500">
//                         {d.owner?.email}
//                       </div>
//                     </td>
//                     <td className="py-2 px-3">Rs. {d.rentAmount}</td>
//                     <td className="py-2 px-3">Rs. {d.serviceCharge}</td>
//                     <td className="py-2 px-3 text-center">
//                       <button
//                         onClick={() => navigate(`/deal/${d.id}`)}
//                         className="px-3 py-1.5 rounded-full text-xs font-medium bg-indigo-500 text-white hover:bg-indigo-600"
//                       >
//                         View Details & Verify
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}
//       </div>

//       {/* Completed deals */}
//       <div className="bg-white rounded-xl shadow p-6">
//         <div className="flex items-center justify-between mb-4">
//           <h2 className="text-lg font-semibold">Completed Deals</h2>
//           <span className="text-sm text-gray-500">
//             {stats.completedDeals.length} completed
//           </span>
//         </div>

//         {stats.completedDeals.length === 0 ? (
//           <p className="text-gray-500 text-sm">No completed deals yet.</p>
//         ) : (
//           <div className="overflow-x-auto">
//             <table className="w-full text-sm">
//               <thead className="border-b bg-gray-50">
//                 <tr className="text-left">
//                   <th className="py-2 px-3">Room</th>
//                   <th className="py-2 px-3">Seeker</th>
//                   <th className="py-2 px-3">Owner</th>
//                   <th className="py-2 px-3">Rent (Rs.)</th>
//                   <th className="py-2 px-3">Service Charge (Rs.)</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {stats.completedDeals.map((d) => (
//                   <tr
//                     key={d.id}
//                     className="border-b last:border-0 hover:bg-gray-50/60"
//                   >
//                     <td className="py-2 px-3">
//                       <div className="font-semibold text-gray-900">
//                         {d.listing?.title || "N/A"}
//                       </div>
//                       <div className="text-xs text-gray-500">
//                         {d.listing?.location}
//                       </div>
//                     </td>
//                     <td className="py-2 px-3">
//                       <div className="text-sm">
//                         {d.seeker?.fullName || "Unknown seeker"}
//                       </div>
//                       <div className="text-xs text-gray-500">
//                         {d.seeker?.email}
//                       </div>
//                     </td>
//                     <td className="py-2 px-3">
//                       <div className="text-sm">
//                         {d.owner?.fullName || "Unknown owner"}
//                       </div>
//                       <div className="text-xs text-gray-500">
//                         {d.owner?.email}
//                       </div>
//                     </td>
//                     <td className="py-2 px-3">Rs. {d.rentAmount}</td>
//                     <td className="py-2 px-3">Rs. {d.serviceCharge}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}
//       </div>

//       {/* Listing details modal */}
//       {showDetails && selectedListing && (
//         <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/40">
//           <div className="bg-white rounded-2xl shadow-xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
//             {/* Header */}
//             <div className="flex items-start justify-between p-5 border-b border-gray-100">
//               <div>
//                 <h3 className="text-lg font-semibold text-gray-900">
//                   {selectedListing.title}
//                 </h3>
//                 <p className="text-xs text-gray-500 mt-1">
//                   {selectedListing.roomType} • Rs. {selectedListing.rentAmount}
//                 </p>
//               </div>
//               <button
//                 onClick={closeDetails}
//                 className="text-gray-400 hover:text-gray-600 text-xl leading-none"
//               >
//                 ×
//               </button>
//             </div>

//             {/* Body */}
//             <div className="p-5 space-y-4 text-sm text-gray-800">
//               <div className="grid md:grid-cols-2 gap-4">
//                 <div>
//                   <div className="text-xs font-semibold text-gray-500 mb-1">
//                     Owner
//                   </div>
//                   <div className="text-sm">
//                     {selectedListing.owner?.fullName || "Unknown owner"}
//                   </div>
//                   <div className="text-xs text-gray-500">
//                     {selectedListing.owner?.email}
//                   </div>
//                 </div>
//                 <div>
//                   <div className="text-xs font-semibold text-gray-500 mb-1">
//                     Listing Info
//                   </div>
//                   <div>
//                     <span className="font-medium">Location:</span>{" "}
//                     {selectedListing.location || "-"}
//                   </div>
//                   <div>
//                     <span className="font-medium">Created:</span>{" "}
//                     {selectedListing.createdAt
//                       ? new Date(selectedListing.createdAt).toLocaleString()
//                       : "-"}
//                   </div>
//                   {selectedListing.rooms != null && (
//                     <div>
//                       <span className="font-medium">Rooms:</span>{" "}
//                       {selectedListing.rooms}
//                     </div>
//                   )}
//                 </div>
//               </div>

//               {selectedListing.description && (
//                 <div>
//                   <div className="text-xs font-semibold text-gray-500 mb-1">
//                     Description
//                   </div>
//                   <p className="text-sm text-gray-800 whitespace-pre-wrap">
//                     {selectedListing.description}
//                   </p>
//                 </div>
//               )}

//               {Array.isArray(selectedListing.facilities) &&
//                 selectedListing.facilities.length > 0 && (
//                   <div>
//                     <div className="text-xs font-semibold text-gray-500 mb-1">
//                       Facilities / Amenities
//                     </div>
//                     <div className="flex flex-wrap gap-2">
//                       {selectedListing.facilities.map((f) => (
//                         <span
//                           key={f}
//                           className="px-2.5 py-1 rounded-full bg-gray-100 text-xs text-gray-700"
//                         >
//                           {f}
//                         </span>
//                       ))}
//                     </div>
//                   </div>
//                 )}

//               {(selectedListing.kitchen != null ||
//                 selectedListing.bathroom != null) && (
//                 <div className="flex flex-wrap gap-4 text-xs text-gray-700">
//                   {selectedListing.kitchen != null && (
//                     <div>
//                       <span className="font-semibold">Kitchen:</span>{" "}
//                       {selectedListing.kitchen ? "Available" : "Not available"}
//                     </div>
//                   )}
//                   {selectedListing.bathroom != null && (
//                     <div>
//                       <span className="font-semibold">Bathroom:</span>{" "}
//                       {selectedListing.bathroom
//                         ? "Private"
//                         : "Shared / Not private"}
//                     </div>
//                   )}
//                 </div>
//               )}

//               {Array.isArray(selectedListing.images) &&
//                 selectedListing.images.length > 0 && (
//                   <div>
//                     <div className="text-xs font-semibold text-gray-500 mb-1">
//                       Photos
//                     </div>
//                     <div className="grid grid-cols-3 gap-2">
//                       {selectedListing.images.map((src, idx) => (
//                         <img
//                           key={idx}
//                           src={getImageUrl(src)}
//                           alt={`Listing ${selectedListing.id} - ${idx + 1}`}
//                           className="w-full h-24 object-cover rounded-lg border border-gray-100"
//                         />
//                       ))}
//                     </div>
//                   </div>
//                 )}
//             </div>

//             {/* Footer */}
//             <div className="flex items-center justify-between p-5 border-t border-gray-100">
//               <div className="text-xs text-gray-500">
//                 Review the details carefully before approving or rejecting.
//               </div>
//               <div className="flex gap-2">
//                 <button
//                   onClick={() => handleReview(selectedListing.id, "APPROVED")}
//                   className="px-4 py-1.5 rounded-full text-xs font-medium bg-emerald-50 text-emerald-700 border border-emerald-100 hover:bg-emerald-100"
//                 >
//                   Approve
//                 </button>
//                 <button
//                   onClick={() => handleReview(selectedListing.id, "REJECTED")}
//                   className="px-4 py-1.5 rounded-full text-xs font-medium bg-red-50 text-red-700 border border-red-100 hover:bg-red-100"
//                 >
//                   Reject
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// src/pages/Admin/AdminDashboardPage.jsx

import React, { useEffect, useState, useContext } from "react";

import toast from "react-hot-toast";
import api from "../../utils/api";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { getImageUrl } from "../../utils/imageUrl";

export default function AdminDashboardPage() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  const [stats, setStats] = useState({
    totalListings: 0,
    pendingApprovals: 0,
    confirmedDeals: 0,
    revenue: 0,

    pendingListings: [],
    dealsAwaitingVerification: [],
    completedDeals: [],

    // NEW
    seekerQueries: [],
  });

  // Listing modal
  const [selectedListing, setSelectedListing] = useState(null);

  const [showDetails, setShowDetails] = useState(false);

  // Seeker query modal
  const [selectedQuery, setSelectedQuery] = useState(null);

  const [showQueryDetails, setShowQueryDetails] = useState(false);

  /*
  |--------------------------------------------------------------------------
  | LOAD DASHBOARD
  |--------------------------------------------------------------------------
  */

  useEffect(() => {
    if (!user) {
      navigate("/login");
      return;
    }

    if (user.role !== "ADMIN") {
      navigate("/");
      return;
    }

    async function load() {
      try {
        setLoading(true);

        const res = await api.get("/admin/dashboard");

        console.log("Dashboard data:", res.data.seekerQueries);

        setStats({
          totalListings: res.data?.totalListings || 0,

          pendingApprovals: res.data?.pendingApprovals || 0,

          confirmedDeals: res.data?.confirmedDeals || 0,

          revenue: res.data?.revenue || 0,

          pendingListings: Array.isArray(res.data?.pendingListings)
            ? res.data.pendingListings
            : [],

          dealsAwaitingVerification: Array.isArray(
            res.data?.dealsAwaitingVerification,
          )
            ? res.data.dealsAwaitingVerification
            : [],

          completedDeals: Array.isArray(res.data?.completedDeals)
            ? res.data.completedDeals
            : [],

          // NEW
          seekerQueries: Array.isArray(res.data?.seekerQueries)
            ? res.data.seekerQueries
            : [],
        });
      } catch (err) {
        console.error(err);

        toast.error(
          err?.response?.data?.message || "Failed to load admin dashboard",
        );
      } finally {
        setLoading(false);
      }
    }

    load();
  }, [user, navigate]);

  /*
  |--------------------------------------------------------------------------
  | APPROVE / REJECT LISTING
  |--------------------------------------------------------------------------
  */

  async function handleReview(listingId, nextStatus) {
    const remarks =
      nextStatus === "REJECTED"
        ? window.prompt("Reason for rejection (optional):") || ""
        : "";

    try {
      await api.put(`/admin/listings/${listingId}/review`, {
        status: nextStatus,
        remarks,
      });

      setStats((prev) => ({
        ...prev,

        pendingApprovals: Math.max(prev.pendingApprovals - 1, 0),

        pendingListings: prev.pendingListings.filter((l) => l.id !== listingId),
      }));

      if (selectedListing && selectedListing.id === listingId) {
        setShowDetails(false);
        setSelectedListing(null);
      }

      toast.success(`Listing ${nextStatus.toLowerCase()} successfully`);
    } catch (err) {
      console.error(err);

      toast.error(err?.response?.data?.message || "Failed to update listing");
    }
  }

  /*
  |--------------------------------------------------------------------------
  | LISTING MODAL
  |--------------------------------------------------------------------------
  */

  function openListingDetails(listing) {
    setSelectedListing(listing);
    setShowDetails(true);
  }

  function closeDetails() {
    setShowDetails(false);
    setSelectedListing(null);
  }

  /*
  |--------------------------------------------------------------------------
  | SEEKER QUERY MODAL
  |--------------------------------------------------------------------------
  */

  function openQueryDetails(query) {
    setSelectedQuery(query);
    setShowQueryDetails(true);
  }

  function closeQueryDetails() {
    setShowQueryDetails(false);
    setSelectedQuery(null);
  }

  /*
  |--------------------------------------------------------------------------
  | Update quries staus
  |--------------------------------------------------------------------------
  */
  async function handleInquiryStatusChange(inquiryId, newStatus) {
    try {
      await api.put(`/admin/inquiries/${inquiryId}/status`, {
        status: newStatus,
      });

      // Update UI immediately
      setStats((prev) => ({
        ...prev,

        seekerQueries: prev.seekerQueries.map((query) =>
          query.id === inquiryId
            ? {
                ...query,
                status: newStatus,
              }
            : query,
        ),
      }));

      toast.success("Inquiry status updated successfully");
    } catch (err) {
      console.error("Failed to update inquiry status:", err);

      toast.error(
        err?.response?.data?.message || "Failed to update inquiry status",
      );
    }
  }

  /*
  |--------------------------------------------------------------------------
  | LOADING
  |--------------------------------------------------------------------------
  */

  if (loading) {
    return (
      <div className="max-w-7xl mx-auto px-6 py-10">
        Loading admin dashboard...
      </div>
    );
  }

  /*
  |--------------------------------------------------------------------------
  | PAGE
  |--------------------------------------------------------------------------
  */

  return (
    <div className="max-w-7xl mx-auto px-6 py-10">
      {/* ================================================================
          HEADER
      ================================================================ */}

      <div className="mb-6">
        <h1 className="text-3xl font-semibold">Admin Dashboard</h1>

        <p className="text-gray-500">
          Manage room listings, seeker queries, and verify completed deals.
        </p>
      </div>

      {/* ================================================================
          TOP STATS
      ================================================================ */}

      <div
        className="
        grid
        grid-cols-1
        md:grid-cols-5
        gap-6
        mb-8
      "
      >
        {[
          {
            label: "Total Listings",
            value: stats.totalListings,
          },

          {
            label: "Pending Listing Approvals",
            value: stats.pendingApprovals,
          },

          {
            label: "Seeker Queries",
            value: stats.seekerQueries.length,
          },

          {
            label: "Confirmed Deals",
            value: stats.confirmedDeals,
          },

          {
            label: "Total Revenue",
            value: `Rs. ${stats.revenue}`,
          },
        ].map((box, i) => (
          <div
            key={i}
            className="
              bg-white
              shadow
              rounded-xl
              p-6
              text-center
              border
              border-gray-50
            "
          >
            <div
              className="
              text-2xl
              font-bold
              text-gray-900
            "
            >
              {box.value}
            </div>

            <div
              className="
              text-gray-500
              text-sm
              mt-1
            "
            >
              {box.label}
            </div>
          </div>
        ))}
      </div>

      {/* ================================================================
          SEEKER ROOM QUERIES
      ================================================================ */}

      <div
        className="
        bg-white
        rounded-xl
        shadow
        p-6
        mb-8
      "
      >
        <div
          className="
          flex
          items-center
          justify-between
          mb-4
        "
        >
          <div>
            <h2
              className="
              text-lg
              font-semibold
            "
            >
              Seeker Room Queries
            </h2>

            <p
              className="
              text-sm
              text-gray-500
              mt-1
            "
            >
              Room requirements submitted by seekers.
            </p>
          </div>

          <span
            className="
            text-sm
            text-gray-500
          "
          >
            {stats.seekerQueries.length} queries
          </span>
        </div>

        {stats.seekerQueries.length === 0 ? (
          <div
            className="
      py-8
      text-center
      text-gray-500
      text-sm
    "
          >
            No seeker inquiries submitted yet.
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              {/* =====================================================
          TABLE HEADER
      ===================================================== */}

              <thead className="border-b bg-gray-50">
                <tr className="text-left">
                  <th className="py-3 px-3">Seeker</th>

                  <th className="py-3 px-3">Phone</th>

                  <th className="py-3 px-3">Property Type</th>

                  <th className="py-3 px-3">Budget</th>

                  <th className="py-3 px-3">Preferred Locations</th>

                  <th className="py-3 px-3">City</th>

                  <th className="py-3 px-3">Move In</th>

                  <th className="py-3 px-3">Status</th>

                  <th className="py-3 px-3 text-center">Action</th>
                </tr>
              </thead>

              {/* =====================================================
          TABLE BODY
      ===================================================== */}

              <tbody>
                {stats.seekerQueries.map((query) => (
                  <tr
                    key={query.id}
                    className="
              border-b
              last:border-0
              hover:bg-gray-50/60
            "
                  >
                    {/* =================================================
                SEEKER
            ================================================= */}

                    <td className="py-3 px-3">
                      <div
                        className="
                font-semibold
                text-gray-900
              "
                      >
                        {query.fullName || "Unknown"}
                      </div>

                      <div
                        className="
                text-xs
                text-gray-500
                mt-1
              "
                      >
                        {query.email || "-"}
                      </div>
                    </td>

                    {/* =================================================
                PHONE
            ================================================= */}

                    <td className="py-3 px-3 whitespace-nowrap">
                      {query.phone || "-"}
                    </td>

                    {/* =================================================
                PROPERTY TYPE
            ================================================= */}

                    <td className="py-3 px-3">
                      {query.propertyType ? (
                        <span
                          className="
                    inline-flex
                    px-2.5
                    py-1
                    rounded-full
                    bg-orange-50
                    text-orange-600
                    text-xs
                    font-medium
                  "
                        >
                          {query.propertyType}
                        </span>
                      ) : (
                        "-"
                      )}
                    </td>

                    {/* =================================================
                BUDGET
            ================================================= */}

                    <td
                      className="
                py-3
                px-3
                whitespace-nowrap
              "
                    >
                      {query.minBudget || query.maxBudget ? (
                        <div className="text-sm">
                          {query.minBudget && (
                            <span>
                              Rs. {Number(query.minBudget).toLocaleString()}
                            </span>
                          )}

                          {query.minBudget && query.maxBudget && (
                            <span className="mx-1">-</span>
                          )}

                          {query.maxBudget && (
                            <span>
                              Rs. {Number(query.maxBudget).toLocaleString()}
                            </span>
                          )}
                        </div>
                      ) : (
                        <span className="text-gray-400">Not specified</span>
                      )}
                    </td>

                    {/* =================================================
                PREFERRED LOCATIONS
            ================================================= */}

                    <td
                      className="
                py-3
                px-3
                max-w-xs
              "
                    >
                      {Array.isArray(query.preferredAreas) &&
                      query.preferredAreas.length > 0 ? (
                        <div
                          className="
                    flex
                    flex-wrap
                    gap-1
                  "
                        >
                          {query.preferredAreas.slice(0, 3).map((area) => (
                            <span
                              key={area}
                              className="
                          px-2
                          py-1
                          rounded-full
                          bg-blue-50
                          text-blue-600
                          text-xs
                        "
                            >
                              {area}
                            </span>
                          ))}

                          {query.preferredAreas.length > 3 && (
                            <span
                              className="
                        px-2
                        py-1
                        text-xs
                        text-gray-500
                      "
                            >
                              +{query.preferredAreas.length - 3} more
                            </span>
                          )}
                        </div>
                      ) : (
                        <span className="text-gray-400">No preference</span>
                      )}
                    </td>

                    {/* =================================================
                CITY
            ================================================= */}

                    <td className="py-3 px-3">{query.city || "-"}</td>

                    {/* =================================================
                MOVE IN DATE
            ================================================= */}

                    <td
                      className="
              py-3
              px-3
              whitespace-nowrap
            "
                    >
                      {query.moveInDate ? (
                        new Date(query.moveInDate).toLocaleDateString()
                      ) : (
                        <span className="text-gray-400">Flexible</span>
                      )}
                    </td>

                    {/* =================================================
                STATUS
            ================================================= */}

                    <td className="py-3 px-3">
                      <select
                        value={query.status || "PENDING"}
                        onChange={(e) =>
                          handleInquiryStatusChange(query.id, e.target.value)
                        }
                        className={`
                          px-3
                          py-1.5
                          rounded-full
                          text-xs
                          font-medium
                          border
                          cursor-pointer
                          outline-none
                          focus:ring-2
                          focus:ring-offset-1

                          ${
                            query.status === "PENDING"
                              ? "bg-yellow-50 text-yellow-700 border-yellow-200 focus:ring-yellow-300"
                              : query.status === "CONTACTED"
                                ? "bg-purple-50 text-purple-700 border-purple-200 focus:ring-purple-300"
                                : query.status === "MATCH_FOUND"
                                  ? "bg-blue-50 text-blue-700 border-blue-200 focus:ring-blue-300"
                                  : query.status === "COMPLETED"
                                    ? "bg-green-50 text-green-700 border-green-200 focus:ring-green-300"
                                    : query.status === "CANCELLED"
                                      ? "bg-red-50 text-red-700 border-red-200 focus:ring-red-300"
                                      : "bg-gray-100 text-gray-700 border-gray-200 focus:ring-gray-300"
                          }
                        `}
                      >
                        <option value="PENDING">Pending</option>

                        <option value="CONTACTED">Contacted</option>

                        <option value="MATCH_FOUND">Match Found</option>

                        <option value="COMPLETED">Completed</option>

                        <option value="CANCELLED">Cancelled</option>
                      </select>
                    </td>

                    {/* =================================================
                ACTION
            ================================================= */}

                    <td
                      className="
                py-3
                px-3
                text-center
              "
                    >
                      <button
                        onClick={() => openQueryDetails(query)}
                        className="
                  px-3
                  py-1.5
                  rounded-full
                  text-xs
                  font-medium
                  bg-indigo-50
                  text-indigo-700
                  border
                  border-indigo-100
                  hover:bg-indigo-100
                "
                      >
                        View Details
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* ================================================================
          PENDING LISTINGS
      ================================================================ */}

      <div
        className="
        bg-white
        rounded-xl
        shadow
        p-6
        mb-8
      "
      >
        <div
          className="
          flex
          items-center
          justify-between
          mb-4
        "
        >
          <h2
            className="
            text-lg
            font-semibold
          "
          >
            Pending Listings
          </h2>

          <span
            className="
            text-sm
            text-gray-500
          "
          >
            {stats.pendingListings.length} pending approval
          </span>
        </div>

        {stats.pendingListings.length === 0 ? (
          <p
            className="
            text-gray-500
            text-sm
          "
          >
            No pending listings at the moment.
          </p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead
                className="
                border-b
                bg-gray-50
              "
              >
                <tr className="text-left">
                  <th className="py-2 px-3">Title</th>

                  <th className="py-2 px-3">Owner</th>

                  <th className="py-2 px-3">Location</th>

                  <th className="py-2 px-3">Rent (Rs.)</th>

                  <th className="py-2 px-3">Created</th>

                  <th
                    className="
                    py-2
                    px-3
                    text-center
                  "
                  >
                    Action
                  </th>
                </tr>
              </thead>

              <tbody>
                {stats.pendingListings.map((listing) => (
                  <tr
                    key={listing.id}
                    className="
                        border-b
                        last:border-0
                        hover:bg-gray-50/60
                      "
                  >
                    <td className="py-2 px-3">
                      <div
                        className="
                          font-semibold
                          text-gray-900
                        "
                      >
                        {listing.title}
                      </div>

                      <div
                        className="
                          text-xs
                          text-gray-500
                        "
                      >
                        Type: {listing.roomType}
                      </div>
                    </td>

                    <td className="py-2 px-3">
                      <div className="text-sm">
                        {listing.owner?.fullName || "Unknown owner"}
                      </div>

                      <div
                        className="
                          text-xs
                          text-gray-500
                        "
                      >
                        {listing.owner?.email}
                      </div>
                    </td>

                    <td className="py-2 px-3">{listing.location}</td>

                    <td className="py-2 px-3">Rs. {listing.rentAmount}</td>

                    <td
                      className="
                        py-2
                        px-3
                        text-xs
                        text-gray-500
                      "
                    >
                      {listing.createdAt
                        ? new Date(listing.createdAt).toLocaleDateString()
                        : "-"}
                    </td>

                    <td className="py-2 px-3">
                      <div
                        className="
                          flex
                          gap-2
                          justify-center
                          flex-wrap
                        "
                      >
                        <button
                          onClick={() => openListingDetails(listing)}
                          className="
                              px-3
                              py-1
                              rounded-full
                              text-xs
                              font-medium
                              border
                              border-gray-300
                              text-gray-700
                              hover:bg-gray-100
                            "
                        >
                          View
                        </button>

                        <button
                          onClick={() => handleReview(listing.id, "APPROVED")}
                          className="
                              px-3
                              py-1
                              rounded-full
                              text-xs
                              font-medium
                              bg-emerald-50
                              text-emerald-700
                              border
                              border-emerald-100
                              hover:bg-emerald-100
                            "
                        >
                          Approve
                        </button>

                        <button
                          onClick={() => handleReview(listing.id, "REJECTED")}
                          className="
                              px-3
                              py-1
                              rounded-full
                              text-xs
                              font-medium
                              bg-red-50
                              text-red-700
                              border
                              border-red-100
                              hover:bg-red-100
                            "
                        >
                          Reject
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* ================================================================
          DEALS AWAITING VERIFICATION
      ================================================================ */}

      <div
        className="
        bg-white
        rounded-xl
        shadow
        p-6
        mb-8
      "
      >
        <div
          className="
          flex
          items-center
          justify-between
          mb-4
        "
        >
          <h2
            className="
            text-lg
            font-semibold
          "
          >
            Deals Awaiting Verification
          </h2>

          <span
            className="
            text-sm
            text-gray-500
          "
          >
            {stats.dealsAwaitingVerification.length} pending confirmation
          </span>
        </div>

        {stats.dealsAwaitingVerification.length === 0 ? (
          <p
            className="
            text-gray-500
            text-sm
          "
          >
            No deals waiting for admin verification right now.
          </p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead
                className="
                border-b
                bg-gray-50
              "
              >
                <tr className="text-left">
                  <th className="py-2 px-3">Room</th>

                  <th className="py-2 px-3">Seeker</th>

                  <th className="py-2 px-3">Owner</th>

                  <th className="py-2 px-3">Rent (Rs.)</th>

                  <th className="py-2 px-3">Service Charge (Rs.)</th>

                  <th
                    className="
                    py-2
                    px-3
                    text-center
                  "
                  >
                    Action
                  </th>
                </tr>
              </thead>

              <tbody>
                {stats.dealsAwaitingVerification.map((d) => (
                  <tr
                    key={d.id}
                    className="
                        border-b
                        last:border-0
                        hover:bg-gray-50/60
                      "
                  >
                    <td className="py-2 px-3">
                      <div
                        className="
                          font-semibold
                          text-gray-900
                        "
                      >
                        {d.listing?.title || "N/A"}
                      </div>

                      <div
                        className="
                          text-xs
                          text-gray-500
                        "
                      >
                        {d.listing?.location}
                      </div>
                    </td>

                    <td className="py-2 px-3">
                      <div className="text-sm">
                        {d.seeker?.fullName || "Unknown seeker"}
                      </div>

                      <div
                        className="
                          text-xs
                          text-gray-500
                        "
                      >
                        {d.seeker?.email}
                      </div>
                    </td>

                    <td className="py-2 px-3">
                      <div className="text-sm">
                        {d.owner?.fullName || "Unknown owner"}
                      </div>

                      <div
                        className="
                          text-xs
                          text-gray-500
                        "
                      >
                        {d.owner?.email}
                      </div>
                    </td>

                    <td className="py-2 px-3">Rs. {d.rentAmount}</td>

                    <td className="py-2 px-3">Rs. {d.serviceCharge}</td>

                    <td
                      className="
                        py-2
                        px-3
                        text-center
                      "
                    >
                      <button
                        onClick={() => navigate(`/deal/${d.id}`)}
                        className="
                            px-3
                            py-1.5
                            rounded-full
                            text-xs
                            font-medium
                            bg-indigo-500
                            text-white
                            hover:bg-indigo-600
                          "
                      >
                        View Details & Verify
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* ================================================================
          COMPLETED DEALS
      ================================================================ */}

      <div
        className="
        bg-white
        rounded-xl
        shadow
        p-6
      "
      >
        <div
          className="
          flex
          items-center
          justify-between
          mb-4
        "
        >
          <h2
            className="
            text-lg
            font-semibold
          "
          >
            Completed Deals
          </h2>

          <span
            className="
            text-sm
            text-gray-500
          "
          >
            {stats.completedDeals.length} completed
          </span>
        </div>

        {stats.completedDeals.length === 0 ? (
          <p
            className="
            text-gray-500
            text-sm
          "
          >
            No completed deals yet.
          </p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead
                className="
                border-b
                bg-gray-50
              "
              >
                <tr className="text-left">
                  <th className="py-2 px-3">Room</th>

                  <th className="py-2 px-3">Seeker</th>

                  <th className="py-2 px-3">Owner</th>

                  <th className="py-2 px-3">Rent (Rs.)</th>

                  <th className="py-2 px-3">Service Charge (Rs.)</th>
                </tr>
              </thead>

              <tbody>
                {stats.completedDeals.map((d) => (
                  <tr
                    key={d.id}
                    className="
                        border-b
                        last:border-0
                        hover:bg-gray-50/60
                      "
                  >
                    <td className="py-2 px-3">
                      <div
                        className="
                          font-semibold
                          text-gray-900
                        "
                      >
                        {d.listing?.title || "N/A"}
                      </div>

                      <div
                        className="
                          text-xs
                          text-gray-500
                        "
                      >
                        {d.listing?.location}
                      </div>
                    </td>

                    <td className="py-2 px-3">
                      <div className="text-sm">
                        {d.seeker?.fullName || "Unknown seeker"}
                      </div>

                      <div
                        className="
                          text-xs
                          text-gray-500
                        "
                      >
                        {d.seeker?.email}
                      </div>
                    </td>

                    <td className="py-2 px-3">
                      <div className="text-sm">
                        {d.owner?.fullName || "Unknown owner"}
                      </div>

                      <div
                        className="
                          text-xs
                          text-gray-500
                        "
                      >
                        {d.owner?.email}
                      </div>
                    </td>

                    <td className="py-2 px-3">Rs. {d.rentAmount}</td>

                    <td className="py-2 px-3">Rs. {d.serviceCharge}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* ================================================================
          LISTING DETAILS MODAL
      ================================================================ */}

      {showDetails && selectedListing && (
        <div
          className="
            fixed
            inset-0
            z-40
            flex
            items-center
            justify-center
            bg-black/40
            p-4
          "
        >
          <div
            className="
              bg-white
              rounded-2xl
              shadow-xl
              max-w-2xl
              w-full
              max-h-[90vh]
              overflow-y-auto
            "
          >
            {/* HEADER */}

            <div
              className="
                flex
                items-start
                justify-between
                p-5
                border-b
                border-gray-100
              "
            >
              <div>
                <h3
                  className="
                    text-lg
                    font-semibold
                    text-gray-900
                  "
                >
                  {selectedListing.title}
                </h3>

                <p
                  className="
                    text-xs
                    text-gray-500
                    mt-1
                  "
                >
                  {selectedListing.roomType}
                  {" • "}
                  Rs. {selectedListing.rentAmount}
                </p>
              </div>

              <button
                onClick={closeDetails}
                className="
                    text-gray-400
                    hover:text-gray-600
                    text-xl
                  "
              >
                ×
              </button>
            </div>

            {/* BODY */}

            <div
              className="
                p-5
                space-y-4
                text-sm
                text-gray-800
              "
            >
              <div
                className="
                  grid
                  md:grid-cols-2
                  gap-4
                "
              >
                <div>
                  <div
                    className="
                      text-xs
                      font-semibold
                      text-gray-500
                      mb-1
                    "
                  >
                    Owner
                  </div>

                  <div>
                    {selectedListing.owner?.fullName || "Unknown owner"}
                  </div>

                  <div
                    className="
                      text-xs
                      text-gray-500
                    "
                  >
                    {selectedListing.owner?.email}
                  </div>
                </div>

                <div>
                  <div
                    className="
                      text-xs
                      font-semibold
                      text-gray-500
                      mb-1
                    "
                  >
                    Listing Info
                  </div>

                  <div>
                    <span className="font-medium">Location:</span>{" "}
                    {selectedListing.location || "-"}
                  </div>

                  <div>
                    <span className="font-medium">Created:</span>{" "}
                    {selectedListing.createdAt
                      ? new Date(selectedListing.createdAt).toLocaleString()
                      : "-"}
                  </div>

                  {selectedListing.rooms != null && (
                    <div>
                      <span className="font-medium">Rooms:</span>{" "}
                      {selectedListing.rooms}
                    </div>
                  )}
                </div>
              </div>

              {selectedListing.description && (
                <div>
                  <div
                    className="
                      text-xs
                      font-semibold
                      text-gray-500
                      mb-1
                    "
                  >
                    Description
                  </div>

                  <p
                    className="
                      text-sm
                      whitespace-pre-wrap
                    "
                  >
                    {selectedListing.description}
                  </p>
                </div>
              )}

              {Array.isArray(selectedListing.facilities) &&
                selectedListing.facilities.length > 0 && (
                  <div>
                    <div
                      className="
                        text-xs
                        font-semibold
                        text-gray-500
                        mb-1
                      "
                    >
                      Facilities / Amenities
                    </div>

                    <div
                      className="
                        flex
                        flex-wrap
                        gap-2
                      "
                    >
                      {selectedListing.facilities.map((f) => (
                        <span
                          key={f}
                          className="
                                px-2.5
                                py-1
                                rounded-full
                                bg-gray-100
                                text-xs
                              "
                        >
                          {f}
                        </span>
                      ))}
                    </div>
                  </div>
                )}

              {(selectedListing.kitchen != null ||
                selectedListing.bathroom != null) && (
                <div
                  className="
                    flex
                    flex-wrap
                    gap-4
                    text-xs
                  "
                >
                  {selectedListing.kitchen != null && (
                    <div>
                      <span className="font-semibold">Kitchen:</span>{" "}
                      {selectedListing.kitchen ? "Available" : "Not available"}
                    </div>
                  )}

                  {selectedListing.bathroom != null && (
                    <div>
                      <span className="font-semibold">Bathroom:</span>{" "}
                      {selectedListing.bathroom
                        ? "Private"
                        : "Shared / Not private"}
                    </div>
                  )}
                </div>
              )}

              {Array.isArray(selectedListing.images) &&
                selectedListing.images.length > 0 && (
                  <div>
                    <div
                      className="
                        text-xs
                        font-semibold
                        text-gray-500
                        mb-1
                      "
                    >
                      Photos
                    </div>

                    <div
                      className="
                        grid
                        grid-cols-3
                        gap-2
                      "
                    >
                      {selectedListing.images.map((src, idx) => (
                        <img
                          key={idx}
                          src={getImageUrl(src)}
                          alt={`Listing ${selectedListing.id} - ${idx + 1}`}
                          className="
                                w-full
                                h-24
                                object-cover
                                rounded-lg
                                border
                              "
                        />
                      ))}
                    </div>
                  </div>
                )}
            </div>

            {/* FOOTER */}

            <div
              className="
                flex
                items-center
                justify-between
                p-5
                border-t
                border-gray-100
              "
            >
              <div
                className="
                  text-xs
                  text-gray-500
                "
              >
                Review the details carefully.
              </div>

              <div className="flex gap-2">
                <button
                  onClick={() => handleReview(selectedListing.id, "APPROVED")}
                  className="
                      px-4
                      py-1.5
                      rounded-full
                      text-xs
                      font-medium
                      bg-emerald-50
                      text-emerald-700
                    "
                >
                  Approve
                </button>

                <button
                  onClick={() => handleReview(selectedListing.id, "REJECTED")}
                  className="
                      px-4
                      py-1.5
                      rounded-full
                      text-xs
                      font-medium
                      bg-red-50
                      text-red-700
                    "
                >
                  Reject
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ================================================================
          SEEKER QUERY DETAILS MODAL
      ================================================================ */}

      {showQueryDetails && selectedQuery && (
        <div
          className="
      fixed
      inset-0
      z-50
      flex
      items-center
      justify-center
      bg-black/50
      p-4
    "
        >
          <div
            className="
        bg-white
        rounded-2xl
        shadow-xl
        max-w-3xl
        w-full
        max-h-[90vh]
        overflow-y-auto
      "
          >
            {/* =====================================================
          HEADER
      ===================================================== */}

            <div
              className="
          flex
          items-start
          justify-between
          p-6
          border-b
          border-gray-100
          sticky
          top-0
          bg-white
          z-10
        "
            >
              <div>
                <h3
                  className="
              text-xl
              font-semibold
              text-gray-900
            "
                >
                  Seeker Room Requirement
                </h3>

                <p
                  className="
              text-sm
              text-gray-500
              mt-1
            "
                >
                  Submitted{" "}
                  {selectedQuery.createdAt
                    ? new Date(selectedQuery.createdAt).toLocaleString()
                    : "-"}
                </p>
              </div>

              <button
                onClick={closeQueryDetails}
                className="
            text-gray-400
            hover:text-gray-700
            text-2xl
            leading-none
          "
              >
                ×
              </button>
            </div>

            {/* =====================================================
          BODY
      ===================================================== */}

            <div
              className="
          p-6
          space-y-7
        "
            >
              {/* ===================================================
            SEEKER INFORMATION
        =================================================== */}

              <section>
                <h4
                  className="
              text-sm
              font-semibold
              text-gray-900
              mb-3
            "
                >
                  Seeker Information
                </h4>

                <div
                  className="
              grid
              md:grid-cols-3
              gap-4
            "
                >
                  {/* NAME */}

                  <div className="bg-gray-50 rounded-xl p-4">
                    <div className="text-xs text-gray-500 mb-1">Full Name</div>

                    <div className="font-medium text-gray-900">
                      {selectedQuery.fullName || "-"}
                    </div>
                  </div>

                  {/* PHONE */}

                  <div className="bg-gray-50 rounded-xl p-4">
                    <div className="text-xs text-gray-500 mb-1">Phone</div>

                    <div className="font-medium text-gray-900">
                      {selectedQuery.phone || "-"}
                    </div>
                  </div>

                  {/* EMAIL */}

                  <div className="bg-gray-50 rounded-xl p-4">
                    <div className="text-xs text-gray-500 mb-1">Email</div>

                    <div className="font-medium text-gray-900 break-all">
                      {selectedQuery.email || "-"}
                    </div>
                  </div>
                </div>
              </section>

              {/* ===================================================
            PROPERTY REQUIREMENT
        =================================================== */}

              <section>
                <h4
                  className="
              text-sm
              font-semibold
              text-gray-900
              mb-3
            "
                >
                  Property Requirement
                </h4>

                <div
                  className="
              grid
              md:grid-cols-3
              gap-4
            "
                >
                  {/* PROPERTY TYPE */}

                  <div
                    className="
                border
                border-gray-100
                rounded-xl
                p-4
              "
                  >
                    <div className="text-xs text-gray-500 mb-2">
                      Property Type
                    </div>

                    <span
                      className="
                  inline-flex
                  px-3
                  py-1.5
                  rounded-full
                  bg-orange-100
                  text-orange-700
                  text-xs
                  font-medium
                "
                    >
                      {selectedQuery.propertyType || "-"}
                    </span>
                  </div>

                  {/* MINIMUM BUDGET */}

                  <div
                    className="
                border
                border-gray-100
                rounded-xl
                p-4
              "
                  >
                    <div className="text-xs text-gray-500 mb-2">
                      Minimum Budget
                    </div>

                    <div
                      className="
                  font-semibold
                  text-lg
                  text-orange-600
                "
                    >
                      {selectedQuery.minBudget
                        ? `Rs. ${Number(
                            selectedQuery.minBudget,
                          ).toLocaleString()}`
                        : "Not specified"}
                    </div>
                  </div>

                  {/* MAXIMUM BUDGET */}

                  <div
                    className="
                border
                border-gray-100
                rounded-xl
                p-4
              "
                  >
                    <div className="text-xs text-gray-500 mb-2">
                      Maximum Budget
                    </div>

                    <div
                      className="
                  font-semibold
                  text-lg
                  text-orange-600
                "
                    >
                      {selectedQuery.maxBudget
                        ? `Rs. ${Number(
                            selectedQuery.maxBudget,
                          ).toLocaleString()}`
                        : "Not specified"}
                    </div>
                  </div>
                </div>
              </section>

              {/* ===================================================
            LOCATION
        =================================================== */}

              <section>
                <h4
                  className="
              text-sm
              font-semibold
              text-gray-900
              mb-3
            "
                >
                  Location Preference
                </h4>

                {/* CITY */}

                <div
                  className="
              bg-orange-50
              border
              border-orange-100
              rounded-xl
              p-4
              mb-4
            "
                >
                  <div
                    className="
                text-xs
                text-orange-600
                font-medium
              "
                  >
                    Preferred City
                  </div>

                  <div
                    className="
                text-lg
                font-semibold
                text-gray-900
                mt-1
              "
                  >
                    {selectedQuery.city || "City not specified"}
                  </div>
                </div>

                {/* PREFERRED AREAS */}

                <div>
                  <div
                    className="
                text-xs
                font-semibold
                text-gray-500
                mb-2
              "
                  >
                    Preferred Areas
                  </div>

                  {Array.isArray(selectedQuery.preferredAreas) &&
                  selectedQuery.preferredAreas.length > 0 ? (
                    <div
                      className="
                  flex
                  flex-wrap
                  gap-2
                "
                    >
                      {selectedQuery.preferredAreas.map((area) => (
                        <span
                          key={area}
                          className="
                        px-3
                        py-2
                        rounded-xl
                        bg-blue-50
                        border
                        border-blue-100
                        text-blue-700
                        text-sm
                      "
                        >
                          📍 {area}
                        </span>
                      ))}
                    </div>
                  ) : (
                    <p className="text-sm text-gray-500">
                      No preferred areas specified.
                    </p>
                  )}
                </div>
              </section>

              {/* ===================================================
            MOVE-IN & LEASE
        =================================================== */}

              <section>
                <h4
                  className="
              text-sm
              font-semibold
              text-gray-900
              mb-3
            "
                >
                  Move-in & Lease Preference
                </h4>

                <div
                  className="
              grid
              md:grid-cols-2
              gap-4
            "
                >
                  {/* MOVE IN DATE */}

                  <div
                    className="
                bg-gray-50
                rounded-xl
                p-4
              "
                  >
                    <div className="text-xs text-gray-500 mb-1">
                      Preferred Move-in Date
                    </div>

                    <div className="font-medium text-gray-900">
                      {selectedQuery.moveInDate
                        ? new Date(
                            selectedQuery.moveInDate,
                          ).toLocaleDateString()
                        : "Flexible"}
                    </div>
                  </div>

                  {/* LEASE */}

                  <div
                    className="
                bg-gray-50
                rounded-xl
                p-4
              "
                  >
                    <div className="text-xs text-gray-500 mb-1">
                      Lease Duration
                    </div>

                    <div className="font-medium text-gray-900">
                      {selectedQuery.leaseDuration || "Flexible"}
                    </div>
                  </div>
                </div>
              </section>

              {/* ===================================================
            ROOM PREFERENCES
        =================================================== */}

              <section>
                <h4
                  className="
              text-sm
              font-semibold
              text-gray-900
              mb-3
            "
                >
                  Room Preferences
                </h4>

                <div
                  className="
              grid
              grid-cols-2
              md:grid-cols-4
              gap-3
            "
                >
                  {/* ROOMS */}

                  <div
                    className="
                border
                border-gray-100
                rounded-xl
                p-4
                text-center
              "
                  >
                    <div className="text-xs text-gray-500 mb-1">Rooms</div>

                    <div className="font-semibold text-gray-900">
                      {selectedQuery.rooms ?? "Any"}
                    </div>
                  </div>

                  {/* KITCHEN */}

                  <div
                    className="
                border
                border-gray-100
                rounded-xl
                p-4
                text-center
              "
                  >
                    <div className="text-xs text-gray-500 mb-1">Kitchen</div>

                    <div
                      className={
                        selectedQuery.kitchen
                          ? "text-green-600 font-semibold"
                          : "text-gray-500"
                      }
                    >
                      {selectedQuery.kitchen ? "Required" : "Not Required"}
                    </div>
                  </div>

                  {/* BATHROOM */}

                  <div
                    className="
                border
                border-gray-100
                rounded-xl
                p-4
                text-center
              "
                  >
                    <div className="text-xs text-gray-500 mb-1">Bathroom</div>

                    <div
                      className={
                        selectedQuery.bathroom
                          ? "text-green-600 font-semibold"
                          : "text-gray-500"
                      }
                    >
                      {selectedQuery.bathroom ? "Required" : "Not Required"}
                    </div>
                  </div>

                  {/* PARKING */}

                  <div
                    className="
                border
                border-gray-100
                rounded-xl
                p-4
                text-center
              "
                  >
                    <div className="text-xs text-gray-500 mb-1">Parking</div>

                    <div
                      className={
                        selectedQuery.parking
                          ? "text-green-600 font-semibold"
                          : "text-gray-500"
                      }
                    >
                      {selectedQuery.parking ? "Required" : "Not Required"}
                    </div>
                  </div>
                </div>
              </section>

              {/* ===================================================
            FURNISHING
        =================================================== */}

              <section>
                <h4
                  className="
              text-sm
              font-semibold
              text-gray-900
              mb-3
            "
                >
                  Furnishing Preference
                </h4>

                <div
                  className="
              bg-gray-50
              rounded-xl
              p-4
            "
                >
                  <span className="font-medium text-gray-900">
                    {selectedQuery.furnished
                      ? selectedQuery.furnished
                      : "No preference"}
                  </span>
                </div>
              </section>

              {/* ===================================================
            AMENITIES
        =================================================== */}

              <section>
                <h4
                  className="
              text-sm
              font-semibold
              text-gray-900
              mb-3
            "
                >
                  Required Amenities
                </h4>

                {Array.isArray(selectedQuery.amenities) &&
                selectedQuery.amenities.length > 0 ? (
                  <div
                    className="
                flex
                flex-wrap
                gap-2
              "
                  >
                    {selectedQuery.amenities.map((amenity) => (
                      <span
                        key={amenity}
                        className="
                      px-3
                      py-1.5
                      rounded-full
                      bg-green-50
                      border
                      border-green-100
                      text-green-700
                      text-xs
                      font-medium
                    "
                      >
                        ✓ {amenity}
                      </span>
                    ))}
                  </div>
                ) : (
                  <p className="text-sm text-gray-500">
                    No specific amenities requested.
                  </p>
                )}
              </section>

              {/* ===================================================
            STATUS
        =================================================== */}

              <section>
                <div
                  className="
              flex
              flex-col
              md:flex-row
              md:items-center
              md:justify-between
              gap-3
              bg-yellow-50
              border
              border-yellow-100
              rounded-xl
              p-4
            "
                >
                  <div>
                    <div
                      className="
                  text-xs
                  text-yellow-700
                  font-medium
                "
                    >
                      Inquiry Status
                    </div>

                    <div
                      className="
                  font-semibold
                  text-gray-900
                  mt-1
                "
                    >
                      {selectedQuery.status || "PENDING"}
                    </div>
                  </div>

                  <div
                    className="
                text-xs
                text-gray-500
              "
                  >
                    Last Updated:{" "}
                    {selectedQuery.updatedAt
                      ? new Date(selectedQuery.updatedAt).toLocaleString()
                      : "-"}
                  </div>
                </div>
              </section>
            </div>

            {/* =====================================================
          FOOTER
      ===================================================== */}

            <div
              className="
          flex
          flex-col
          sm:flex-row
          sm:justify-between
          sm:items-center
          gap-3
          p-5
          border-t
          border-gray-100
        "
            >
              <div
                className="
            text-xs
            text-gray-500
          "
              >
                Use this information to identify matching listings for the
                seeker.
              </div>

              <button
                onClick={closeQueryDetails}
                className="
            px-5
            py-2
            rounded-xl
            bg-gray-900
            text-white
            text-sm
            hover:bg-gray-800
          "
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
